var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5685 8.48837C19.66 8.50428 19.7483 8.54884 19.8243 8.62509L22.8575 11.6583C23.0465 11.8473 23.0465 12.1529 22.8575 12.3419L19.8243 15.3751C19.5203 15.6801 19.0001 15.4633 19.0001 15.0333V13.0001H2.0001C1.86758 13.002 1.73602 12.9775 1.61305 12.9281C1.49008 12.8787 1.37816 12.8053 1.28379 12.7123C1.18942 12.6192 1.11449 12.5083 1.06334 12.3861C1.01219 12.2638 0.985853 12.1326 0.985853 12.0001C0.985853 11.8676 1.01219 11.7364 1.06334 11.6141C1.11449 11.4918 1.18942 11.381 1.28379 11.2879C1.37816 11.1949 1.49008 11.1215 1.61305 11.0721C1.73602 11.0227 1.86758 10.9982 2.0001 11.0001H19.0001V8.96689C19.0001 8.64364 19.2937 8.44066 19.5685 8.48837Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowRight);
export default __webpack_public_path__ + "static/media/long_arrow_right.9906c65b84dfe4c59ad120b5d1a1cec7.svg";
export { ForwardRef as ReactComponent };